<script setup lang="ts">
import { eventBus } from '@/eventBus'

const { t } = useI18n()
const { add } = useMath()
const userStore = useUserStore()
const { payFixedFee } = storeToRefs(userStore)
const { format } = useDayjs()
const { addTrack } = useReport()

const showModal = ref(false)
const data = ref()
const iframeElement = ref<HTMLIFrameElement | null>(null)
useLockAppScrollWhenVisible(showModal)

const isSubmitting = ref(false)
const payStatus = ref(1)

const payTitleMap: any = {
  1: t('Copywriting.ConfirmCollectionPurchase'),
  0: t('Copywriting.ConfirmSubscriptionPurchase'),
  2: t('Copywriting.ConfirmMessagePurchase'),
  4: t('Copywriting.ConfirmSinglePostPurchase'),
  3: t('Copywriting.ConfirmTips'),
  5: t('Copywriting.ConfirmSubscriptionPurchase'),
}

const close = () => {
  showModal.value = false
}

const open = (d: any) => {
  payStatus.value = 1
  isSubmitting.value = false
  data.value = d
  // data.value.payUrl = `http://192.168.3.7:3334/paypal?isDark=${isDark.value}&channelPayNo=${d?.channelPayNo}`
  data.value.payUrl = `${d.payUrl}?isDark=${isDark.value}&channelPayNo=${d?.channelPayNo}`
  showModal.value = true
  addTrack({
    event: 'page_view',
    extra: {
      eventType: 'paypal_modal_open',
      ...d,
    },
    page: window.location.href,
    referrer: window.location.href,
    timestamp: Date.now(),
  })
}

const captureOrder = async () => {
  if (!data.value.payNo) {
    return
  }
  try {
    const res = await walletService.captureOrder(data.value.payNo)
    payStatus.value = res.status
    if (res.status === 2) {
      eventBus.emit('buyChange')
      close()
    }
  } catch (error) {
    console.log(error)
  }
}

const onIframeLoad = () => {
  addTrack({
    event: 'page_view',
    extra: {
      eventType: 'paypal_modal_iframe_finash',
      ...data.value,
    },
    page: window.location.href,
    referrer: window.location.href,
    timestamp: Date.now(),
  })
}
window.addEventListener('message', event => {
  if (event.data.type === 'paypalSuccess') {
    isSubmitting.value = true
    captureOrder()
  }
  if (event.data.type === 'paypalButtonClicked') {
    addTrack({
      event: 'button_click',
      extra: {
        eventType: 'paypal_button_clicked',
        ...data.value,
      },
      page: window.location.href,
      referrer: window.location.href,
      timestamp: Date.now(),
    })
  }
})

defineExpose({
  open,
  close,
})
</script>

<template>
  <n-modal
    v-model:show="showModal"
    :on-after-leave="close"
    :mask-closable="false"
    :auto-focus="false"
    transform-origin="center"
  >
    <div class="w-11/12 md:w-125">
      <div class="modal-content sm:p-6 p-4 h-155.5 flex flex-col">
        <header class="flex justify-between items-center">
          <div class="text-4.5 sm:text-5.5 leading-6.5 typeface-robotoMedium">
            {{ payTitleMap[data.revenueType] }}
          </div>
          <div i-carbon:close class="cursor-pointer text-6" @click="close" />
        </header>
        <div v-if="data?.amount" my-5 text-base>
          <div>
            {{ t('YouWIllBeCharge', [`$${add(+data?.amount, +payFixedFee)}`]) }}
            <!-- <span
              v-if="
                data?.originalData?.buyInfo?.promotion?.freeTrialDay ||
                data?.originalData?.buyInfo?.promotion?.trailDays
              "
            >
              {{
                t('Global.FreeTrial', [
                  `${data?.originalData?.buyInfo?.promotion?.freeTrialDay || data?.originalData?.buyInfo?.promotion?.trailDays}`,
                ])
              }}
            </span> -->
          </div>
          <div class="text-brandB">${{ data?.amount }} + ${{ payFixedFee }} Fee</div>
        </div>
        <div v-if="isSubmitting">
          <div v-if="payStatus === 0" h-full flex flex-col items-center>
            <!-- 取消支付 -->
            <img src="@/assets/image/cancel.webp" class="w-20 h-20" alt="dfans" />
            <div mt-4 text-5.5 leading-6.5 typeface-robotoMedium>{{ t('Global.TopUpCancel') }}</div>
          </div>
          <div v-if="payStatus === 1" h-full flex flex-col items-center>
            <!-- 支付中 -->
            <img src="@/assets/image/pocessing.webp" class="w-20 h-20" alt="dfans" />
            <div mt-4 text-5.5 leading-6.5 typeface-robotoMedium>
              {{ t('Btn.PaymentProcessing') }}
            </div>
          </div>
          <div v-if="payStatus === 2" h-full flex flex-col items-center>
            <!-- 支付成功 -->
            <img src="@/assets/image/success.webp" class="w-20 h-20" alt="dfans" />
            <div mt-4 text-5.5 leading-6.5 typeface-robotoMedium>
              {{ t('Global.TopUpSuccess') }}
            </div>
            <div mt-3 text-base>
              {{ format(new Date(), 'D MMM YYYY, h:mm a') }}
            </div>
          </div>
        </div>
        <iframe
          v-else
          ref="iframeElement"
          w-full
          h-full
          :src="data.payUrl"
          sandbox="allow-scripts allow-same-origin"
          @load="onIframeLoad"
        />
      </div>
    </div>
  </n-modal>
</template>
